import { AssetContext } from '@pages/Asset/Asset.query';
import React, { useContext } from 'react';

import {
  NoUpdatesText,
  NoUpdatesContainer,
  Strong,
  Span1,
  Span2,
  StrongGrey,
} from '../../Updates.styles';

const TempProduct = () => {
  const { equipmentQuery } = useContext(AssetContext);

  const equipment = equipmentQuery?.data;

  return (
    <NoUpdatesContainer>
      <NoUpdatesText>
        Your asset is connected to a <Strong>temporary product</Strong>.
        Temporary products are created when we cannot find a product from{' '}
        {equipment?.product?.manufacturer?.name} with the information you
        shared. For that reason we cannot bring you updates from{' '}
        {equipment?.product?.manufacturer?.name} for this product.
        <br />
        <br />
        There are two possibilities:
        <br />
        <Span1>1.</Span1> We need a more accurate{' '}
        <StrongGrey>product name</StrongGrey> and/or{' '}
        <StrongGrey>model number</StrongGrey> to find a match.
        <br />
        <Span2>2.</Span2> We unfortunately do not yet have data on this product.
        <br />
      </NoUpdatesText>
    </NoUpdatesContainer>
  );
};

export { TempProduct };
